const utils = {
  prepareTempValue(value) {
    let units = localStorage.getItem('temp_dimension') || 'C';
    if (value && units === 'F') {
      value = Math.round((value * 1.8 + 32) * 10) / 10;
    }
    return value;
  },
  prepareSugarValue(value) {
    let units = localStorage.getItem('sugar_dimension') || 'mg/dL';
    if (value && units == 'mmol/L') {
      value = parseFloat((value / 18.018).toFixed(2));
    }
    return value;
  },
  preparePoseName(value) {
    let data = 'Unknown';
    switch (value) { //  0-stand, 1-sitting, 2-lie low, 3-fall down, 4-walk, 5-run
      case 0:
        data = 'Stand';
        break;
      case 1:
        data = 'Sitting';
        break;
      case 2:
        data = 'Lie low';
        break;
      case 3:
        data = 'Fall down';
        break;
      case 4:
        data = 'Walk';
        break;
      case 5:
        data = 'Run';
        break;
    }
    return data;
  }
}

export default utils;



// WEBPACK FOOTER //
// ./src/plugins/utils.js